<div class="d-flex align-items-center justify-content-between flex-column  h-100">
  <div></div>
  <div class="card border-0">
    <div class="card-header text-start d-none">
      <h4
        class="card-title"
        i18n="@@bot-login-title"
      >Login für Bot "<i>{{ this.botConfig.name }}</i>"</h4>
    </div>
    <div class="card-body">
      <p i18n="@@bot-login-password-hint">Bitte gib das Passwort für diesen Bot ein:</p>
      <div class="input-group mb-3">
        <input
          [type]="this.showPassword ? 'text' : 'password'"
          class="form-control"
          id="botProtect"
          [(ngModel)]="this.botPw"
          (keyup.enter)="this.sendBotPw()"
        >
        <button
          type="button"
          class="btn btn-outline-secondary"
          [attr.aria-label]="this.passwordToggleLabel"
          [attr.title]="this.passwordToggleLabel"
          (click)="this.togglePasswordVisibility()"
        ><i [class]="this.showPassword ? 'ri-eye-off-line' : 'ri-eye-line'"></i></button>
      </div>
      <button
        type="button"
        i18n="@@send"
        class="btn btn-outline-success"
        (click)="this.sendBotPw()"
      >Senden</button>
    </div>
  </div>




  <div>
    <a
      href="https://reflact.com/datenschutz/"
      target="_blank"
      class="text-decoration-none text-muted"
    >
      <small i18n="@@privacy-notice">Datenschutzhinweis</small>
    </a>
  </div>



</div>